




import { Component, Vue, Prop } from 'vue-property-decorator'

import AppTabBar2 from '@/components/AppTabBar2.vue'

@Component({
  components: {
    AppTabBar2
  }
})
export default class extends Vue {
  @Prop(String) readonly where!: string

  tabs = [
    { name: '투데이', to: { name: 'ShoppingToday' } },
    { name: '베스트', to: { name: 'ShoppingBest' } },
    { name: '특가', to: { name: 'ShoppingSpecials' } },
    { name: '카테고리', to: { name: 'ShoppingCategories' } },
    { name: '브랜드', to: { name: 'ShoppingBrands', query: { category: '전체' } } }
  ]
}
